module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/sui-80199cd40b756be02601cb6f0e07a7f8.svg";